import { Component, Input } from '@angular/core';
import { ShoppingCart } from '@queries/generated';
import { ProductCatalogService } from '@services/product-catalog.service';
import { ShoppingCartService } from '@services/shopping-cart.service';
import { Fade } from '@util/animations';
import { IWizard } from '@util/wizard';
import { SidebarToggleComponent } from '../sidebar-toggle/sidebar-toggle.component';

enum ShoppingCartStepsEnum {
  Preview,
  Checkout,
  Payment
}

interface ShoppingCartWizard extends IWizard<ShoppingCartStepsEnum> {}
@Component({
  selector: 'vnm-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss'],
  animations: [Fade]
})
export class ShoppingCartComponent {
  ShoppingCartStepsEnum = ShoppingCartStepsEnum;

  @Input() shoppingCart!: ShoppingCart;

  isCheckoutValid = false;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private catalogService: ProductCatalogService,
    public sidebarToggle: SidebarToggleComponent
  ) {}

  onDismissSidebar() {
    this.sidebarToggle?.close();
    this.shoppingCartService.refresh();
  }

  onBrowseCatalog() {
    this.sidebarToggle?.close();
    this.catalogService.presentCatalog();
  }

  onValidityChange(valid: boolean) {
    this.isCheckoutValid = valid;
  }
}
